import React from "react";
import { SupText, toast, SupXCircle } from "@repo/core-ui";

/**
 * Display error message in the snackbar
 *
 * @param e
 * @param {boolean} persist
 * @param {"success" | "error" | "info" | "warning"} variant
 * @param {number} timer
 */
export function notifyCommon(e: any, persist: boolean = true, variant: "success" | "error" | "info" | "warning" = "error", timer: number = 5000) {
  const regexpResult = /reason="([^"]+)"/gm.exec(e.toString());
  let messageType = variant;
  let message = regexpResult && regexpResult.length > 0 ? regexpResult[regexpResult.length - 1] : e.toString();
  if (message.search("Error: user rejected transaction") !== -1) {
    message = "Transaction was rejected. Try once again.";
    messageType = "warning";
  }
  if (e.message && e.data?.message && e.message === "Internal JSON-RPC error.") {
    message = e.data.message;
  }
  if (["error", "info", "warning"].includes(messageType)) {
    toast.error(
      <SupText variant="button" className="whitespace-break-spaces break-words">
        {message}
      </SupText>,
      {
        icon: <SupXCircle />,
        duration: persist ? 1000000 : timer,
        id: e.toString(),
      }
    );
  } else {
    toast.success(<SupText variant="button">{message}</SupText>, {
      icon: <SupXCircle />,
      duration: persist ? undefined : timer,
      id: e.toString(),
    });
  }
}
